<template>
  <div id="yearly-data">
    <div class="section-header">
      YEARLY DATA
    </div>
    <div id="yearly-data-nav">
      <ul>
        <li
          v-for="y in years"
          :key="y"
          :class="{active: y === year}"
          @click="year = y"
        >{{ y }}</li>
      </ul>
    </div>
    <div id="yearly-data-mobile-dropdown" class="dropdown">
      <select @change="year = $event.target.value">
        <option
          v-for="y in years"
          :key="y"
          :class="{active: y === year}"
          :value="y"
          >{{y}}</option>
      </select>
    </div>
    <div class="charts-container">
      <div class="charts-scroller">
        <div class="year-of-charts" v-if="allVictims.length">
          <TrendChart
            :current-year="currentYear"
            :all-victims="allVictims"
            :trend-length="6"
          />
          <CauseChart
            :year="year"
            :all-victims="allVictims"
          />
          <DistrictChart
            :year="year"
            :all-victims="allVictims"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VictimLoader from "../mixins/VictimLoader.vue";

import CauseChart from "./CauseChart.vue";
import DistrictChart from "./DistrictChart.vue";
import TrendChart from "./TrendChart.vue";

export default {
  name: "VictimsChart",
  components: {
    CauseChart,
    DistrictChart,
    TrendChart
  },
  mixins: [VictimLoader],
  data() {
    let curYear = String(new Date().getFullYear());
    return {
      currentYear: curYear,
      year: curYear
    };
  },
  computed: {
    years() {
      let years = [];
      let y = this.currentYear;
      for (let i = 0; i < 10; i++) {
        years.push(String(y - i));
      }
      return years;
    }
  }
};
</script>


<style lang="scss">
$ct-text-size: 0.75rem;
$ct-series-colors: (
  #da2128 /* alert red */,
  #daa520 /* sun yellow */,
  #bcd2ee /* light blue */,
  #5b889d /* teal */,
  #551033 /* purple */,
  #666666 /* gray */,
  #b11b20 /* dark red */,
  #eee8aa /* light yellow */,
  #22316c /* transporter blue */,
  #e31a1c,
  #1f78b4,
  #33a02c,
  #ff7f00,
  #cab2d6,
  #fdbf6f,
  #a6cee3,
  #b2df8a,
  #fb9a99,
  #6a3d9a,
  #ffff99,
  #b15928,
  #8dd3c7,
  #ffffb3,
  #bebada,
  #fb8072,
  #80b1d3,
  #fdb462,
  #b3de69,
  #fccde5,
  #d9d9d9,
  #bc80bd,
  #ccebc5,
  #ffed6f
);

@import "chartist/dist/scss/chartist.scss";

$gray: rgba(0, 0, 0, 0.4);

.ct-line {
  opacity: 0.9;
  stroke-width: 2px;
}

.homicides-label {
  color: $gray;
}

.legend-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.legend-list li {
  display: inline-block;
  margin: 0 0.5rem;
  line-height: 1.5;

  &:before {
    content: "■ ";
  }
}

@for $i from 0 to length($ct-series-colors) {
  .legend-#{$i} {
    color: nth($ct-series-colors, $i + 1);
  }
}
</style>
